import { render, staticRenderFns } from "./ShortSummaryTest.vue?vue&type=template&id=a9259ffa&scoped=true"
import script from "./ShortSummaryTest.vue?vue&type=script&lang=js"
export * from "./ShortSummaryTest.vue?vue&type=script&lang=js"
import style0 from "./ShortSummaryTest.vue?vue&type=style&index=0&id=a9259ffa&prod&lang=scss&scoped=true"
import style1 from "./ShortSummaryTest.vue?vue&type=style&index=1&id=a9259ffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9259ffa",
  null
  
)

export default component.exports